import { Switch } from 'react-router-dom';
import OSPDF from '../components/OSPDF';
import { PDFProvider } from '../hooks/usePDFData';
import { PDFAssistanceProvider } from '../hooks/usePDFAssistanceData';
import Catalog from '../pages/Catalog';
import Login from '../pages/Login';
import Manual from '../pages/Manual';
import RegisterOS from '../pages/RegisterOS';
import SearchOS from '../pages/SearchOS';
import Route from './Route';
import AssistanceOS from '../pages/AssistanceOS';
import AssistancePDF from '../components/AssistancePDF';

const Routes = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={Login} />
      <Route
        path={`${process.env.PUBLIC_URL}/manual`}
        component={Manual}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/catalog`}
        component={Catalog}
        isPrivate
      />

      <PDFProvider>
        <Route
          path={`${process.env.PUBLIC_URL}/register-os`}
          component={RegisterOS}
          isPrivate
        />
        <Route
          path={`${process.env.PUBLIC_URL}/search-os`}
          component={SearchOS}
          isPrivate
        />
        <Route
          path={`${process.env.PUBLIC_URL}/pdf`}
          component={OSPDF}
          isPrivate
        />
        <PDFAssistanceProvider>
          <Route
            path={`${process.env.PUBLIC_URL}/assistance`}
            component={AssistanceOS}
            isPrivate
          />
          <Route
            path={`${process.env.PUBLIC_URL}/assistance-pdf`}
            component={AssistancePDF}
            isPrivate
          />
        </PDFAssistanceProvider>
      </PDFProvider>
    </Switch>
  );
};

export default Routes;
